function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import Link from "../basic/link";
var globalLang = "en";
var globalContent = "Global (English)";
var getNameFromLangCode = function getNameFromLangCode(type, lang) {
  var codes = lang.split("-");
  var codeForType = type === "language" ? codes[0] : codes[1];
  var name = new Intl.DisplayNames([codes[0]], {
    type: type
  });
  return name.of(codeForType.toUpperCase());
};
var SelectCountryLink = function SelectCountryLink(_ref) {
  var href = _ref.href,
    lang = _ref.lang;
  var _useState = useState(globalContent),
    _useState2 = _slicedToArray(_useState, 2),
    linkContent = _useState2[0],
    setLinkContent = _useState2[1];
  useEffect(function () {
    if (lang !== globalLang) {
      var language = getNameFromLangCode("language", lang);
      var region = getNameFromLangCode("region", lang);
      setLinkContent("".concat(region, " (").concat(language, ") "));
    }
  }, []);
  return /*#__PURE__*/React.createElement(Link, {
    href: href,
    styleName: "select-country-link",
    content: linkContent
  });
};
export default SelectCountryLink;